import { CommandCenterDashboard } from "@/components/dashboard/CommandCenterDashboard";
import { ErrorBoundary } from "@/components/ErrorBoundary";

const CompanyAdminDashboard = () => {
  return (
    <ErrorBoundary fallbackTitle="Dashboard Notice">
      <CommandCenterDashboard />
    </ErrorBoundary>
  );
};

export default CompanyAdminDashboard;
